import { PROYECT, api_get } from "services/api";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { erpEquivalenciesTypes } from "redux/reducers/erpEquivalencies/types";

const {
  HANDLE_ERP_EQUIVALENCIES_INPUTS,
  GET_ERP_EQUIVALENCIES,
  GET_BANK_REFERENCES,
  GET_DATA_FISCAL,
  GET_SHIP_TO_ADDRESS,
  GET_CREDIT_CONDITIONS,
} = erpEquivalenciesTypes;

const mainUrl = `${process.env.REACT_APP_URL}${PROYECT}/customers/erp-equivalencies`;
const bankReferenceUrl = `${process.env.REACT_APP_URL}${PROYECT}/accounts/bank-references`;
const fiscalDataUrl = `${process.env.REACT_APP_URL}${PROYECT}/notes/credit-stamp/fiscal-customer`;

const getAccountUrl = (accountId) => `${process.env.REACT_APP_URL}${PROYECT}/accounts/${accountId}`;

export const handleErpEquivalenciesInputsAction = (key, value) => async dispatch => {
  dispatch({ type: HANDLE_ERP_EQUIVALENCIES_INPUTS, payload: { key, value } });
};

export const getErpEquivalenciesAction = (idStation) => async dispatch => {
  const url = `${mainUrl}/${idStation}`;
  dispatch(startRequestComp('loadingErpEquivalencies'));
  try {
    const data = await api_get(url);
    dispatch({ type: GET_ERP_EQUIVALENCIES, payload: data });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp('loadingErpEquivalencies'));
};

export const getDataFiscalAction = (idAccount, idCustomer, idStation) => async dispatch => {
  const url = `${bankReferenceUrl}/${idAccount}`;
  const urlFiscal = `${fiscalDataUrl}?idCustomer=${idCustomer}&idStation=${idStation}`;
  dispatch(startRequestComp('loadingModErpEquivalencies'));
  try {
    const response = await api_get(url);
    const responseFiscal = await api_get(urlFiscal);
    dispatch({ type: GET_BANK_REFERENCES, payload: response });
    dispatch({ type: GET_DATA_FISCAL, payload: responseFiscal });
    return true;
  } catch (error) {
    dispatch(setSnackbar(error));
    return false;
  } finally {
    dispatch(stopRequestComp('loadingModErpEquivalencies'));
  }
};

export const getCreditConditionsAction = ({ idAccount }) => async dispatch => {
  const ACCOUNT_URL = getAccountUrl(idAccount);
  const url = `${ACCOUNT_URL}/credit-account`;
  dispatch(startRequestComp('loadingErpCreditConditions'));
  try {
    const creditAccount = await api_get(url);
    dispatch({
      type: GET_CREDIT_CONDITIONS,
      payload: creditAccount
    });
    return true;
  } catch (error) {
    dispatch(setSnackbar(error));
    return false;
  } finally {
    dispatch(stopRequestComp('loadingErpCreditConditions'));
  }
};

export const getShipToAddressAction = ({ idAccount }) => async dispatch => {
  const ACCOUNT_URL = getAccountUrl(idAccount);
  const url = `${ACCOUNT_URL}/address`;  
  dispatch(startRequestComp('loadingErpShipToAddress'));
  try {
    const response = await api_get(url);
    dispatch({ type: GET_SHIP_TO_ADDRESS, payload: response });
    return true;
  } catch (error) {
    dispatch(setSnackbar(error));
    return false;
  } finally {
    dispatch(stopRequestComp('loadingErpShipToAddress'));
  }
};
